import { useCallback, useMemo, useState } from 'react';
import {
  ConsumerApiSettings,
  LanguageCode,
  MarketCode,
} from '@silvertours/common-landingpages-view';

import { SearchSuggestion, SuggestProviderInterface } from './types';
import { SuggestProvider } from './SuggestProvider';

export const useSearchSuggestions = (
  language: LanguageCode,
  market: MarketCode,
  settings: ConsumerApiSettings,
) => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<Array<SearchSuggestion> | null>(null);

  const searchSuggestProvider = useMemo<SuggestProviderInterface>(
    () => SuggestProvider.getInstance(settings, language, market),
    [settings, language, market],
  );

  const sendRequest = useCallback(
    (searchString: string) => {
      searchSuggestProvider
        .sendRequest(searchString)
        .then(searchResults => {
          // Request was cancelled, do nothing
          if (searchResults === null) {
            return;
          }
          setLoading(false);
          setResults(searchResults);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [searchSuggestProvider],
  );

  const fetchSuggestions = useCallback(
    (searchString: string) => {
      setLoading(true);
      sendRequest(searchString);
    },
    [sendRequest],
  );

  return {
    clearResults: () => {
      setResults([]);
    },
    fetchSuggestions,
    loading,
    results,
  };
};
